<template>
	<div class="content-item-wrapper">
		<div class="icon-wrapper">
			<slot name="icon"></slot>
		</div>

		<div class="description-wrapper">
			<slot name="description"></slot>
		</div>

		<div class="button-wrapper">
			<button
				class="btn-outline o-sm outline-primary w-100 btn-sell-now button-custom"
				@click="handleClickAction"
			>
				<div class="custom-button-label">
					<i :class="iconClass"></i>
					<span class="custom-label">{{ buttonLabel }}</span>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		buttonLabel: {
			type: String,
			default: '',
		},
		iconClass: {
			type: String,
			default: '',
		},
	},
	methods: {
		handleClickAction() {
			this.$emit('click-action');
		},
	},
};
</script>

<style scoped lang="scss">
.content-item-wrapper {
	width: 100%;
	height: auto;
	min-height: 84px;
	border-radius: 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #ffffff;
	padding: 12px 18px;
	gap: 14px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.075);
    border: 0.5px solid #d9dadd75;
}

.icon-wrapper {
	font-size: 20px;
	color: #0000006b;
}

.description-wrapper {
	width: auto;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.button-wrapper {
	margin-left: auto;
}

button.button-custom {
	border-width: 1px;
	min-width: 108px;
}

.custom-button-label {
	display: flex;
	gap: 6px;
	margin: 0 6px;
	font-size: 14px;
	align-items: center;
	font-weight: 400;
}
</style>
